import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import hexToRGBA from '~helpers/hex-to-rgba';
import SvgFormat from 'common/helpers/svgFormat';

const useStyles = makeStyles(theme => ({
  wrap: {
    padding: '24px 20px',
    backgroundColor: 'rgba(107, 146, 243, 0.1)',
  },
  title: {
    display: 'flex',
  },
  icon: {
    width: '20px',
    height: '20px',
    fill: theme.colors.mainGreen6,
  },
  text: {
    fontSize: '14px',
    lineHeight: '22px',
    color: hexToRGBA(theme.colors.gray10, 0.65),
    marginLeft: '8px',
  },
  tipsList: {
    fontSize: '12px',
    lineHeight: '22px',
    color: hexToRGBA(theme.colors.gray10, 0.65),
    marginTop: '10px',
    paddingLeft: '21px',
  },
}));

const TipsWrap = ({ tipTextList, className, children }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classNames(classes.wrap, className)}>
      <div className={classes.title}>
        <SvgFormat type="tips-basic" className={classes.icon} />
        <span className={classes.text}>{t('landlord.onboarding.tips.title')}</span>
      </div>
      <Choose>
        <When condition={tipTextList?.length > 1}>
          <ul className={classes.tipsList}>
            <For each="item" of={tipTextList} index="index">
              <li key={index}>{item}</li>
            </For>
          </ul>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </div>
  );
};

TipsWrap.propTypes = {
  tipTextList: PropTypes.array,
  className: PropTypes.string,
};

export default TipsWrap;
